<template>
  <div class="quiz-modal">
    <HMModalHeader v-if="quiz" :title="quiz.quiz_name" @close="leaveQuiz">
      <h6 v-if="solvedQuizProp" class="mt-1 me-4 float-left">
        {{ $t('QUIZZES.TEXT.QUESTION') }}
        <span class="font-weight-bold">
          {{ currentQuestionIndexProp }} {{ $t('QUIZZES.TEXT.OF') }}
          {{ solvedQuizProp.quiz.quiz_questions.length }}
        </span>
      </h6>
    </HMModalHeader>
    <div class="container mt-4 mb-5">
      <Quiz
        :studioURL="getStudioURL()"
        :quizId="quizId"
        @solvedQuiz="getsolvedQuizProp"
        @currentQuestionIndex="getCurrentQuestionIndexProp"
        @finish="callOnFinish"
      />
    </div>
  </div>
</template>

<script lang="ts">
import Quiz from '@/components/quizzes/Quiz.vue';
import HMDialog from '@/components/common/HMDialog.vue';

export default {
  name: 'QuizModal',
  components: {
    Quiz,
  },
  props: {
    studioURL: {
      type: String,
    },
    quizId: {
      type: Number,
    },
    quiz: {
      type: Object,
    },
    onFinish: null
  },
  data() {
    return {
      solvedQuizProp: null,
      currentQuestionIndexProp: 1,
    };
  },
  methods: {
    getStudioURL() {
      return this.$studioURL;
    },
    getsolvedQuizProp(value) {
      this.solvedQuizProp = value;
    },
    getCurrentQuestionIndexProp(value) {
      this.currentQuestionIndexProp = value;
    },
    leaveQuiz() {
      this.$modal.show(HMDialog, {
        title: this.$t('QUIZZES.TITLE.EXIT_QUIZ'),
        subtitle: this.$t('GENERAL.TEXT.DO_YOU_REALLY_WANT_TO_DO_IT'),
        text: this.$t(
          'QUIZZES.TEXT.ONLY_ANSWERED_ANSWERS_WILL_BE_SUBMITTED_QUIZ'
        ),
        confirmButton: this.$t('QUIZZES.BUTTON.DISCARD'),
        discardButton: this.$t('QUIZZES.BUTTON.STAY_ON_PAGE'),
        discard: () => {
          console.log('confirmed');
        },
        confirm: () => this.$attrs._close(),
      });
    },
    callOnFinish(solvedQuiz) {
      this.onFinish(solvedQuiz);
      this.$attrs._close()
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/components-variables.scss';

.quiz-modal {
  @include media-breakpoint-up(lg) {
    width: 900px;
  }
}
</style>
